import React from 'react';
import { useLocation } from 'react-router-dom';
import { EcopediaEntry } from '../../../pages/system/advanced/e-copedia';
import useCachedQuery from '../../../shared/hooks/useCachedQuery';

const DEFAULT_ECOPEDIA_LINK = 'https://www.e-conomic.dk/support/e-copedia';
const URL = '/system/advanced/e-copedia/settings';

export const useEcopediaUrl = () => {
    const { pathname } = useLocation();
    const [ecopediaLink, setEcopediaLink] = React.useState<EcopediaEntry | undefined>();
    const { data } = useCachedQuery<EcopediaEntry[]>(URL);

    /**
     * Find and set the corresponding e-copedia link based on the current url pathname
     */
    React.useEffect(() => {
        const ecopediaLink = (data ?? []).find(link => {
            return link.path === pathname;
        });

        if (ecopediaLink) {
            setEcopediaLink(ecopediaLink);
        } else {
            setEcopediaLink(undefined);
        }
    }, [pathname, data]);

    return {
        url: ecopediaLink?.url ?? DEFAULT_ECOPEDIA_LINK,
        label: ecopediaLink?.label ?? 'e-copedia',
    };
};
